/* JOZI — interactions légères : statut ouvert/fermé, onglets de carte, menu mobile. */
(function () {
  'use strict';

  var lang = (document.documentElement.lang || 'fr').toLowerCase();

  function fmtTime(min) {
    var h = Math.floor(min / 60);
    var m = min % 60;
    if (lang.indexOf('fr') === 0) return h + 'h' + (m ? String(m).padStart(2, '0') : '');
    var d = new Date(Date.UTC(2020, 0, 1, h, m));
    return new Intl.DateTimeFormat(lang, { hour: 'numeric', minute: m ? '2-digit' : undefined, timeZone: 'UTC' }).format(d);
  }

  function parisNow() {
    var parts = new Intl.DateTimeFormat('en-GB', { timeZone: 'Europe/Paris', weekday: 'short', hour: '2-digit', minute: '2-digit', hour12: false }).formatToParts(new Date());
    var get = function (t) { var p = parts.find(function (x) { return x.type === t; }); return p ? p.value : ''; };
    var days = { Sun: 0, Mon: 1, Tue: 2, Wed: 3, Thu: 4, Fri: 5, Sat: 6 };
    return { day: days[get('weekday')], min: (Number(get('hour')) % 24) * 60 + Number(get('minute')) };
  }

  function updateStatus(el) {
    var hours;
    try { hours = JSON.parse(el.getAttribute('data-jz-hours')); } catch (e) { return; }
    var now = parisNow();
    var today = hours[String(now.day)];
    var tomorrow = hours[String((now.day + 1) % 7)];
    var label = el.querySelector('.jz-status__label');
    var text;
    var open = false;
    if (today && now.min < today[0]) {
      text = el.dataset.before.replace('{time}', fmtTime(today[0]));
    } else if (today && now.min < today[1]) {
      open = true;
      text = el.dataset.open.replace('{time}', fmtTime(today[1]));
    } else if (tomorrow) {
      text = el.dataset.after.replace('{time}', fmtTime(tomorrow[0]));
    } else {
      text = el.dataset.closed;
    }
    el.classList.toggle('is-open', open);
    if (label) label.textContent = text;
    el.hidden = false;
  }

  function initStatus() {
    var els = document.querySelectorAll('[data-jz-hours]');
    els.forEach(updateStatus);
    if (els.length) setInterval(function () { els.forEach(updateStatus); }, 60000);
  }

  function initTabs() {
    document.querySelectorAll('[data-jz-tabs]').forEach(function (root) {
      var tabs = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
      function select(tab, focus) {
        tabs.forEach(function (t) {
          var on = t === tab;
          t.setAttribute('aria-selected', on ? 'true' : 'false');
          t.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
        if (focus) tab.focus();
      }
      tabs.forEach(function (tab, i) {
        tab.addEventListener('click', function () { select(tab, false); });
        tab.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
          if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
          if (e.key === 'Home') next = tabs[0];
          if (e.key === 'End') next = tabs[tabs.length - 1];
          if (next) { e.preventDefault(); select(next, true); }
        });
      });
    });
  }

  function initDrawer() {
    var btn = document.querySelector('[data-jz-menu-toggle]');
    var drawer = document.getElementById('jz-drawer');
    if (!btn || !drawer) return;
    btn.addEventListener('click', function () {
      var open = drawer.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
    drawer.addEventListener('click', function (e) {
      if (e.target.closest('a')) { drawer.classList.remove('is-open'); btn.setAttribute('aria-expanded', 'false'); }
    });
  }

  function initLang() {
    document.querySelectorAll('[data-jz-locale]').forEach(function (b) {
      b.addEventListener('click', function () {
        var form = document.getElementById('jz-localization');
        if (!form) return;
        form.querySelector('input[name="locale_code"]').value = b.getAttribute('data-jz-locale');
        form.submit();
      });
    });
  }

  function ready(fn) { if (document.readyState !== 'loading') fn(); else document.addEventListener('DOMContentLoaded', fn); }
  ready(function () { initStatus(); initTabs(); initDrawer(); initLang(); });
})();
